import React from 'react';

import Icon from '../Icon/Icon';

const OtherDeviceConnectedIcon = (props) => {
    return (
        <Icon width='48' height='48' viewBox='0 0 64 64' fill='none' {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M32.0838 10.163C30.1705 12.2168 29 14.9717 29 18V46C29 49.1093 30.2339 51.9303 32.2388 54.0002C31.9599 54.8888 31.1298 55.5333 30.1492 55.5333H14.1898C12.9804 55.5333 12 54.5529 12 53.3435V11.1898C12 9.98041 12.9804 9 14.1898 9H30.1492C30.9875 9 31.7158 9.47109 32.0838 10.163ZM32.339 12.2195V51.7805C31.1808 50.1483 30.5 48.1537 30.5 46V18C30.5 15.8463 31.1808 13.8517 32.339 12.2195Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M32.1657 12.4719H32.3384V12.2204C32.2795 12.3033 32.222 12.3871 32.1657 12.4719ZM30.7258 52.0622C31.048 52.5807 31.4104 53.0716 31.8085 53.5307H19.1743C17.5733 53.5307 16.2754 52.2328 16.2754 50.6318V13.9023C16.2754 12.3013 17.5733 11.0034 19.1743 11.0034H31.3725C31.0171 11.4664 30.6961 11.9571 30.4134 12.4719H19.1743C18.3843 12.4719 17.7438 13.1123 17.7438 13.9023V50.6318C17.7438 51.4218 18.3843 52.0622 19.1743 52.0622H30.7258Z'
                fill='#FFFDFB'
            />
            <path
                d='M40.5 8C34.9772 8 30.5 12.4772 30.5 18V46C30.5 51.5229 34.9772 56 40.5 56H43.5C44.7166 56 45.877 55.7588 46.9355 55.3213C47.2864 55.1763 47.5 54.824 47.5 54.4443V54.0762C47.6152 54.0465 47.7284 54.0118 47.8408 53.9756C47.7284 54.0118 47.6152 54.0465 47.5 54.0762V10.1895V9.55566C47.5 9.17601 47.2864 8.82375 46.9355 8.67871C45.877 8.24118 44.7166 8 43.5 8H40.5ZM48.9609 53.4834C48.7562 53.5998 48.5441 53.7047 48.3252 53.7969C48.5441 53.7047 48.7562 53.5999 48.9609 53.4834ZM49 53.4609C50.7929 52.4234 52 50.4861 52 48.2656V16C52 13.7793 50.7932 11.8412 49 10.8037V53.4609ZM48.957 10.7793C48.8802 10.7357 48.8025 10.6936 48.7236 10.6533C48.8025 10.6936 48.8802 10.7357 48.957 10.7793Z'
                fill='#393E44'
            />
            <path fillRule='evenodd' clipRule='evenodd' d='M49 42H52V40H49V42Z' fill='#00D1D2' />
        </Icon>
    );
};

export default OtherDeviceConnectedIcon;
